import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'loadingDetail': false,
  'listDetail': [],
};

export const liquidationsByDays = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.LOADING_LIQUIDATIONS_BY_DAYS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_BY_DAYS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_BY_DAYS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.LOADING_LIQUIDATIONS_BY_DAY_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': true,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_BY_DAY_DETAIL]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'listDetail': action.response.data,
    }),
    [ActionTypes.LOADED_LIQUIDATIONS_BY_DAY_DETAIL_FAILED]: (state, action) => ({
      ...state,
      'loadingDetail': false,
      'listDetail': [],
    }),
  })(state, action);
};
